import Page from "../../finwell/pages/Page";
import { useEffect, useState } from "react";
import LearningPathReportHomeSection from "../../components/Reports/learningPathProgress/LearningPathReportHomeSection";
import CONFIG from "../../utils/config";

export const LearningPathProgressReportPageMobile = () => {
    
    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight + 50}
            console.log('height: ', obj);
            window.parent.postMessage(obj, "*");
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <>
        <div className="container pb-2rem">
                <LearningPathReportHomeSection
                isMobile={true}
            />
        </div>
            
        </>
    )
}

export default LearningPathProgressReportPageMobile;